<template>
  <div>
    <v-card elevation="0">
      <v-card-title>
        <span class="headline pt-6 pl-6">For Invoice</span>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-2"
              fab
              small
              color="primary"
              depressed
              :disabled="selected.length==0"
              v-on="on"
              @click="addAllSelectedItems()"
            >
              <v-icon dark>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <span>Add Selected Item(s)</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-2"
              fab
              small
              depressed
              color="grey lighten-2"
              v-on="on"
              @click="forInvoiceDialog.show = false"
            >
              <v-icon dark>
                mdi-close
              </v-icon>
            </v-btn>
          </template>
          <span>Close</span>
        </v-tooltip>
      </v-card-title>

      <v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

        </v-card-actions>
        <v-data-table
          v-model="selected"
          show-select
          class="pa-6"
          :headers="headers"
          :items="items"
          :loading="loading"
          :items-per-page="1000"
          loading-text="Loading For Invoices..."
          item-key="id"
          no-data-text="No For Invoices Found"
          hide-default-footer
          ref="table">

          <template v-slot:[`item.is_active`]="{ item }">
            <v-chip class="ma-2" v-if="!item.is_active" small>No</v-chip>
            <v-chip class="ma-2" color="primary" v-if="item.is_active" small>Yes</v-chip>
          </template>

          <template v-slot:[`item.shipping_mark`]="{ item }">
            <v-icon
              size="24"
              class="mr-2">
              {{ isShipmentForSea(item.shipment_type) ? 'mdi-ferry' : 'mdi-airplane' }}
            </v-icon>
            {{ item.shipping_mark }}
          </template>

          <template v-slot:[`item.cbm`]="{ item }">
            <span v-if="isShipmentForSea(item.shipment_type)">{{formatNumber(item.cbm) }} CBM</span>
            <span v-if="!isShipmentForSea(item.shipment_type)">{{formatNumber(item.kg) }} KG</span>
          </template>

          <template v-slot:[`item.qty`]="{ item }">
            {{ formatNumber(item.qty) }}
          </template>

          <!-- <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  @click="selectItem(item)">
                  mdi-check-bold
                </v-icon>
              </template>
              <span>Select {{ item.name }}</span>
            </v-tooltip>


          </template> -->

        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    name: 'forInvoiceDialog',
    props: ['forInvoiceDialog'],
    data: () => ({
      loading: false,
      selected: [],
      items: [],
      headers: [
        {
          text: 'Shipping Mark',
          align: 'start',
          value: 'shipping_mark',
          sortable: false,
          width: 250
        },
        {
          text: 'Container',
          align: 'start',
          value: 'container',
          sortable: false
        },
        {
          text: 'Description',
          align: 'start',
          value: 'description',
          sortable: false,
        },
        {
          text: 'Qty',
          align: 'right',
          value: 'qty',
          sortable: false,
        },
        {
          text: 'Measure',
          align: 'right',
          value: 'cbm',
          sortable: false,
        },
        // {
        //   text: 'Action',
        //   value: 'action',
        //   align: 'center',
        //   sortable: false,
        //   width: 70
        // }
      ]
    }),
    computed: {
      ...mapGetters(['formatNumber', 'formatNumberAmount', 'forSea']),
    },
    watch: {
      forInvoiceDialog: {
        handler () {
          this.getItems()
        },
        deep: true
      },
    },
    methods: {
      isShipmentForSea (shipment_type){
        return this.forSea(shipment_type, this)
      },
      addAllSelectedItems () {
        this.forInvoiceDialog.show = false
        this.$emit('selectItem', this.selected)
      },
      selectItem (item) {
        this.forInvoiceDialog.show = false
        this.$emit('selectItem', item)
      },
      getItems () {
        if (this.loading) {
          return false
        }

        let params = []

        if (this.forInvoiceDialog.selected_items.length > 0){
          params.push('no_show_selected_item='+this.forInvoiceDialog.selected_items)
        }

        let queryStr = ''
        params.forEach(param => {
          queryStr+= param
        })

        if(this.forInvoiceDialog.client_id == ''){
          return false
        }

        this.selected = []

        this.loading = true
        let self = this
        this.$http.plain.get('accounting/for-invoices/'+this.forInvoiceDialog.client_id+'?' + queryStr)
          .then(response => {
            this.items = response.data
          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
        }
    },
    mounted() {
      this.getItems()
    },
    components: {
    }
  }
</script>
